const LAYOUT_PREFERENCE_STORAGE_KEY = 'layoutPreference';
const LEGACY_TABLET_MENU_OPEN_STORAGE_KEY = 'tabletMenuOpen';
const LEGACY_TABLET_MENU_ITEM_STORAGE_KEY = 'tabletMenuItemId';

export type StoredLayoutPreference = {
  isMenuPinnedOpen: boolean;
  isTabletMenuOpen: boolean;
  tabletMenuItemId: string | null;
  useNewLayout: boolean;
};

export const DEFAULT_LAYOUT_PREFERENCE: StoredLayoutPreference = {
  isMenuPinnedOpen: false,
  isTabletMenuOpen: false,
  tabletMenuItemId: null,
  useNewLayout: true,
};

export const getStoredLayoutPreference = (): StoredLayoutPreference => {
  const legacyTabletMenuOpen =
    localStorage.getItem(LEGACY_TABLET_MENU_OPEN_STORAGE_KEY) === 'true';
  const legacyTabletMenuItemId = localStorage.getItem(
    LEGACY_TABLET_MENU_ITEM_STORAGE_KEY,
  );
  const storedPreference = localStorage.getItem(LAYOUT_PREFERENCE_STORAGE_KEY);

  if (storedPreference !== null) {
    try {
      const parsedPreference = JSON.parse(
        storedPreference,
      ) as Partial<StoredLayoutPreference>;

      return {
        isMenuPinnedOpen: parsedPreference.isMenuPinnedOpen === true,
        isTabletMenuOpen:
          parsedPreference.isTabletMenuOpen === true ||
          (parsedPreference.isTabletMenuOpen === undefined &&
            legacyTabletMenuOpen),
        tabletMenuItemId:
          typeof parsedPreference.tabletMenuItemId === 'string'
            ? parsedPreference.tabletMenuItemId
            : legacyTabletMenuItemId,
        useNewLayout: parsedPreference.useNewLayout ?? true,
      };
    } catch {
      return DEFAULT_LAYOUT_PREFERENCE;
    }
  }

  try {
    return {
      ...DEFAULT_LAYOUT_PREFERENCE,
      isTabletMenuOpen: legacyTabletMenuOpen,
      tabletMenuItemId: legacyTabletMenuItemId,
    };
  } catch {
    return DEFAULT_LAYOUT_PREFERENCE;
  }
};

export const getLayoutVersion = (): 'legacy' | 'new' =>
  getStoredLayoutPreference().useNewLayout ? 'new' : 'legacy';
